import { Component, OnInit, OnDestroy } from "@angular/core";
import { Store, Action } from "@ngrx/store";
import { Actions } from "@ngrx/effects";
import { AppState } from "@store/app-state";
import { Subscription } from "rxjs/Subscription";
import { EnrolmentsStore } from "@store/enrolment";
import { Enrolment } from "@models/enrolment";
import { NUMBER_OF_CLASSES_PER_TERM } from "@constants/matrix_classes";
import { DisenrolmentParams } from "@services/enrolment";
import { PERFORM_DISENROLMENT, PERFORM_DISENROLMENT_SUCCESS } from "@reducers/enrolments";
import { ModalService } from "@services/modal";

@Component({
  selector: 'disenrolment-form',
  templateUrl: './disenrolment-form.pug',
})
export class DisenrolmentFormComponent implements OnInit, OnDestroy {

  public enrolment: Enrolment
  public numOfClassesArray: number[] = []
  public numOfClasses: number = 0
  public numOfClassesToRefund: number = 0
  public selectedReason: string = null

  private enrolmentsSubscription: Subscription

  constructor(
    private store: Store<AppState>,
    private actions: Actions,
    private modalService: ModalService,
  ) {
      let i = 0
      while (i < NUMBER_OF_CLASSES_PER_TERM) {
        const target = i + 1
        this.numOfClassesArray.push(target)
        i += 1
      }
  }

  ngOnInit() {
    this.enrolmentsSubscription =
      this.store.select("enrolmentsReducer").subscribe((s: EnrolmentsStore) => {
        this.enrolment = s.editableEnrolment
      })

    this.setInitialState()
  }

  getAmountToRefund(): number {
    return this.enrolment.matrixClass.course.cost / this.numOfClassesArray.length * this.numOfClassesToRefund
  }

  setInitialState() {
    // TODO: Calculate this from how many weeks we are into the term.
    this.numOfClassesToRefund = 9
  }

  getStyleForSliderPoint(i: number) {
    return { 'left': `${100 / (this.numOfClassesArray.length - 1) * i}%` }
  }

  getStyleForSliderBarHighlight() {
    return { 'width': `${100 / (this.numOfClassesArray.length - 1) * (this.numOfClassesToRefund - 1)}%` }
  }

  setReasonTo(reason: string) {
    this.selectedReason = reason
  }

  isReasonSelected(reason: string): boolean {
    return this.selectedReason == reason
  }

  clickedSliderPoint(i: number) {
    this.numOfClassesToRefund = this.numOfClassesArray.length - i
  }

  clickedDisenrol() {
    const payload: DisenrolmentParams = {
      enrolment_id: this.enrolment.id,
      refund_amount: this.getAmountToRefund(),
      reason: this.selectedReason,
    }

    this.actions
      .ofType(PERFORM_DISENROLMENT_SUCCESS)
      .take(1)
      .subscribe(() => this.modalService.closeModal())

    this.store.dispatch({ type: PERFORM_DISENROLMENT, payload })
  }

  ngOnDestroy() {
    this.enrolmentsSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/disenrolment-form.ts